import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
export function Hero() {
  return <section id="hero" className="relative h-screen w-full overflow-hidden flex items-center justify-center bg-[#1a1a2e]" data-id="element-114">
      {/* Background with gradient overlay */}
      <div className="absolute inset-0 z-0" data-id="element-115">
        <div className="absolute inset-0 bg-gradient-to-b from-[#1a1a2e]/70 via-[#1a1a2e]/50 to-[#1a1a2e] z-10" data-id="element-116" />
        {/* Abstract luxury background pattern */}
        <div className="absolute inset-0 opacity-20 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#c9a96e] via-[#1a1a2e] to-[#1a1a2e]" data-id="element-117" />
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-[#c9a96e]/10 to-transparent" data-id="element-118" />
      </div>

      <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-119">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-120">
          <span className="inline-block py-1 px-3 border border-[#c9a96e]/50 rounded-full text-[#c9a96e] text-sm tracking-[0.2em] uppercase mb-6" data-id="element-121">
            Premium Wellness Singapore
          </span>

          <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-122">
            <span className="block mb-2" data-id="element-123">新加坡幸福缘</span>
            <span className="block text-2xl md:text-3xl lg:text-4xl font-light text-gray-300 mt-4 tracking-wide font-sans" data-id="element-124">
              Singapore Happiness Connection
            </span>
          </h1>

          <p className="max-w-2xl mx-auto text-lg md:text-xl text-gray-300 mb-10 leading-relaxed font-light" data-id="element-125">
            新加坡领先的专业按摩与伴游服务平台
            <br data-id="element-126" />
            <span className="text-sm md:text-base opacity-80 mt-2 block" data-id="element-127">
              Premium Massage & Companion Services in Singapore
            </span>
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-128">
            <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="px-8 py-4 bg-[#c9a96e] text-[#1a1a2e] font-semibold text-lg rounded-sm hover:bg-[#d4af37] transition-all duration-300 transform hover:-translate-y-1 shadow-lg shadow-[#c9a96e]/20 flex items-center gap-2" data-id="element-129">
              Telegram Channel
              <ChevronRight size={18} data-id="element-130" />
            </a>
            <a href="https://www.geylang777-5.site" target="_blank" rel="noopener noreferrer" className="px-8 py-4 border border-white/30 text-white font-medium text-lg rounded-sm hover:bg-white/10 transition-all duration-300 backdrop-blur-sm" data-id="element-131">
              访问官网 (Website)
            </a>
            <a href="https://www.cfge.me" target="_blank" rel="noopener noreferrer" className="px-8 py-4 border border-white/30 text-white font-medium text-lg rounded-sm hover:bg-white/10 transition-all duration-300 backdrop-blur-sm" data-id="element-132">
              新加坡春风阁
            </a>
          </div>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} className="absolute bottom-10 left-1/2 transform -translate-x-1/2 flex flex-col items-center text-white/50" data-id="element-133">
        <span className="text-xs uppercase tracking-widest mb-2" data-id="element-134">Scroll</span>
        <div className="w-[1px] h-12 bg-gradient-to-b from-white/50 to-transparent" data-id="element-135" />
      </motion.div>
    </section>;
}